import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { fixMediaUrl } from '../../../Shared/api/drupal/drupalApi';
import { hyphenate } from "../../../Shared/features/hyphenate";
import { renderContents } from "../../custom_components/components/jumbo/jumboUtils";
import { LinkButton } from '../../custom_components/components/library/button';
import { trackJumboButton } from '../../custom_components/components/library/tracking';
const JumboHeading = (props)=>{
    const { supertitle, title, subtitle } = props;
    return /*#__PURE__*/ _jsxs("header", {
        children: [
            supertitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__supertitle title--md",
                children: supertitle
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "jumbotron__title title--xl title--bg",
                children: hyphenate(title)
            }),
            subtitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__subtitle title--md",
                children: subtitle
            })
        ]
    });
};
const homeJumbo = (props)=>/*#__PURE__*/ _jsx("header", {
        className: "jumbotron jumbotron--home",
        children: /*#__PURE__*/ _jsx("div", {
            className: "jumbotron__outer container--full gutter--m align--center",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "jumbotron__inner",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "jumbotron__content container--s",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "jumbotron__title title--xl title--bg",
                                dangerouslySetInnerHTML: {
                                    __html: unEntity(convertTitleForBackground(props.title))
                                }
                            }),
                            props.buttonUrl && props.buttonTitle && /*#__PURE__*/ _jsx(LinkButton, {
                                variant: "black",
                                arrow: false,
                                route: props.buttonUrl,
                                handle: ()=>trackJumboButton(props.buttonTitle),
                                className: "button button--primary button--arrow jumbotron__clickable",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "button__label",
                                    children: props.buttonTitle
                                })
                            })
                        ]
                    }),
                    props.imageUrl && /*#__PURE__*/ _jsx("div", {
                        className: "jumbotron__visual fit-object",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsxs("picture", {
                            children: [
                                /*#__PURE__*/ _jsx("source", {
                                    media: "(max-width: 500px)",
                                    srcSet: fixMediaUrl(props.imageStyles['440x440'])
                                }),
                                /*#__PURE__*/ _jsx("source", {
                                    media: "(max-width: 800px)",
                                    srcSet: fixMediaUrl(props.imageStyles['790x445'])
                                }),
                                /*#__PURE__*/ _jsx("img", {
                                    src: fixMediaUrl(props.imageStyles['1280x720']),
                                    alt: props.imageAlt
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
export const largeJumbo = (props)=>{
    const { imageStyles, imageUrl, imageUrlLarge, imageUrlSmall, imageAlt } = props;
    const imageSmall = (imageStyles === null || imageStyles === void 0 ? void 0 : imageStyles['470x470']) || imageUrlSmall;
    const imageMedium = (imageStyles === null || imageStyles === void 0 ? void 0 : imageStyles['790x445']) || imageUrl;
    const imageLarge = (imageStyles === null || imageStyles === void 0 ? void 0 : imageStyles['1280x720']) || imageUrlLarge;
    return /*#__PURE__*/ _jsx("header", {
        className: `jumbotron jumbotron--large jumbotron--default ${props.kind && `jumbotron--${props.kind}`}`,
        children: /*#__PURE__*/ _jsx("div", {
            className: "jumbotron__outer",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "jumbotron__inner container--full gutter--m align--center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "jumbotron__content container--s",
                        children: [
                            /*#__PURE__*/ _jsx(JumboHeading, {
                                ...props,
                                h1ClassName: "jumbotron__title title--xl"
                            }),
                            props.contents.toString().length > 0 || props.buttonUrl && props.buttonTitle ? /*#__PURE__*/ _jsxs("div", {
                                className: "jumbotron__intro",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "text--styled",
                                        children: props.contents.toString().length > 0 && renderContents(props.contents, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {}))
                                    }),
                                    props.openingHoursComponent,
                                    props.buttonUrl && props.buttonTitle && /*#__PURE__*/ _jsx(LinkButton, {
                                        arrow: true,
                                        route: props.buttonUrl,
                                        handle: ()=>trackJumboButton(props.buttonTitle),
                                        className: "jumbotron__clickable",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "button__label",
                                            children: props.buttonTitle
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                        ]
                    }),
                    imageMedium && /*#__PURE__*/ _jsxs("div", {
                        className: "jumbotron__visual fit-object",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: imageSmall,
                                srcSet: `${imageSmall} 470w, ${imageMedium} 940w, ${imageLarge} 1880w`,
                                width: "940",
                                height: "507",
                                alt: imageAlt
                            }),
                            /*#__PURE__*/ _jsxs("picture", {
                                children: [
                                    /*#__PURE__*/ _jsx("source", {
                                        media: "(max-width: 500px)",
                                        srcSet: fixMediaUrl(imageSmall)
                                    }),
                                    /*#__PURE__*/ _jsx("source", {
                                        media: "(max-width: 800px)",
                                        srcSet: fixMediaUrl(imageMedium)
                                    }),
                                    /*#__PURE__*/ _jsx("img", {
                                        src: fixMediaUrl(imageLarge),
                                        alt: props.imageAlt
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
export default homeJumbo;
export const unEntity = (str)=>{
    str = str || '';
    return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
};
export const convertTitleForBackground = (title)=>{
    let titleWords = title.split(' ');
    titleWords = titleWords.map((v, k)=>{
        return `<span aria-hidden="true"><span>${v}</span></span>`;
    });
    return `<span class="sr-text">${title}</span>${titleWords.join('')}</div>`;
};
